import { render, staticRenderFns } from "./AccountTabMySettings.vue?vue&type=template&id=0b5469c8&scoped=true"
import script from "./AccountTabMySettings.vue?vue&type=script&lang=js"
export * from "./AccountTabMySettings.vue?vue&type=script&lang=js"
import style0 from "./AccountTabMySettings.vue?vue&type=style&index=0&id=0b5469c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5469c8",
  null
  
)

export default component.exports